module.exports = __webpack_public_path__ + "img/263-6.20316e6e.png";